module.exports = __webpack_public_path__ + "static/Gotham-Thin-0e40a7e2da369bfd5d951be523a29bab.woff";